import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedVenue: {
    isOnline: true,
    venueAddressOne: "Cheezious Lahore",
    venueAddressTwo: "Shad Bagh Lahore"
  },
  logoUrl: '',
  orderType: 'storeDelivery',
  paymentMethod: "cash",
  orderData: {},
  customerInfo: {
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
  },

};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setOrderType: (state, action) => {
      state.orderType = action.payload;
    },
    setOrderData: (state, action) => {
      state.orderData = action.payload;
    },
    setPaymentMethod: (state, action) => {
      state.paymentMethod = action.payload;
    },
    setLogoUrl: (state, action) => {
      state.logoUrl = action.payload;
    },
    setSelectedVenue: (state, action) => {
      state.selectedVenue = action.payload;
    },
    setCustomerInfo: (state, action) => {
      state.customerInfo = action.payload;
    },
  },
});

export const { setSelectedVenue,setOrderData, setPaymentMethod, setLogoUrl, setCustomerInfo, setOrderType } = themeSlice.actions;
export default themeSlice.reducer;
